<template>
    <div>
        <h3>{{$t('instance.instance_details.instance_advanced_settings.title')}}</h3>
        <v-form
            ref="formExtraSettings"
            v-model="formValid"
            lazy-validation
        >
            <div
                v-for="(setting,index) in form"
                :key="index"
            >
                <v-card>
                    <div>
                        <span>{{$t('instance.instance_details.instance_advanced_settings.card_title')}}</span>
                        <span
                            class="delete-params-section"
                            @click="deleteParameter(setting)"
                        >
                            <v-icon type="error">delete</v-icon>
                            {{$t('instance.instance_details.instance_advanced_settings.card_delete')}}
                        </span>
                    </div>
                    <v-text-field
                        v-model="setting.key"
                        :label="$t('instance.instance_details.instance_advanced_settings.key_field')"
                        :rules="formActive ?settingsKeyRules:[]"
                    ></v-text-field>
                    <v-text-field
                        v-model="setting.value"
                        :label="$t('instance.instance_details.instance_advanced_settings.value_field')"
                        :rules="formActive?settingsValuesRules:[]"
                    ></v-text-field>
                </v-card>
            </div>
        </v-form>
        <div v-if="displayNewParameterButton">
            <span
                @click="addNewParameter()"
                class="add-new-param"
            >
                <v-icon>add</v-icon>
                {{$t('instance.instance_details.instance_advanced_settings.add_new_setting')}}
            </span>
        </div>
        <div class="general-buttons-content">
            <v-btn
                @click="cancelCreatingNewSetting()"
            >
                {{$t('instance.instance_details.instance_advanced_settings.cancel_button')}}
            </v-btn>
            <v-btn
                @click="saveParameters()"
                :disabled="!dataHasChanged"
            >
                {{$t('instance.instance_details.instance_advanced_settings.save_button')}}
            </v-btn>
        </div>
    </div>
</template>

<script>
import rulesMixins from '@/components/Mixins/rulesMixins.vue';
export default {
    mixins: [rulesMixins],

    name: 'advanced-params-details',

    props:{
        instance: {
            type: Object,
            required: true,
        },
    },
    data () {
        return {
            form:[],
            oldForm: [], // Used to check if data has changed
            formValid: false,
            settingsDeleted: false,
            settingsKeyRules: [
                v => !!v || this.$t('instance.instance_details.instance_advanced_settings.rules'),
                v => {
                    return this.checkIfKeyExists(v) || 'Key already exists'
                }
            ],
            settingsValuesRules: [
                v => !!v || this.$t('instance.instance_details.instance_advanced_settings.rules'),
            ],

        };
    },
    created(){
        let settings = []
        for (let [key, value] of Object.entries(this.instance.extra_settings)) {
            settings.push({
                key: key,
                value: value,
            })
        }
        this.$set(this, 'form', settings);
        this.$set(this, 'oldForm', JSON.parse(JSON.stringify(settings)));
    },
    computed:{
        displayNewParameterButton(){
            return !this.form.some((setting)=>{
                return setting.value === '' || setting.key === '';
            })
        },
        allKeys(){
            let allKeys = [];
            this.form.map(setting=>{
                allKeys.push(setting.key)
            });
            return allKeys;
        },
        dataHasChanged(){
            if(this.settingsDeleted){
                return true;
            }
            /*
                We check if settings in this.form are NOT
                equal to old value then store changes in changedData.
                If changedData.length !== 0 we return true.
            */
            let changedData = this.form.filter(setting => {
                return !this.oldForm.some(oldSetting => {
                    return setting.key === oldSetting.key;
                });
            });
            return changedData.length !== 0;
        }
    },

    watch:{
    },
    methods: {
        checkIfKeyExists(key){
            /*
                if key has the same index from the beginning and from the end
                there is no duplicate in this.allKeys.
            */
            return this.allKeys.indexOf(key) === this.allKeys.lastIndexOf(key);
        },
        cancelCreatingNewSetting(){
            if(this.dataHasChanged){
                this.$confirm(
                    this.$t('instance.instance_details.instance_advanced_settings.confirm_cancel_text'),
                    this.$t('instance.instance_details.instance_advanced_settings.confirm_cancel_title'), {
                        confirmButtonText: this.$t('instance.instance_details.instance_advanced_settings.confirm_button_cancel'),
                        cancelButtonText: this.$t('instance.instance_details.instance_advanced_settings.cancel_button_cancel'),
                    })
                .then(() => {
                    //TODO: Find if data needs to be resetted on instance details close
                    this.$eventBus.$emit('close-instance-details');
                });
            } else {
                this.$eventBus.$emit('close-instance-details');
            }
        },
        addNewParameter(){
            this.form.push({
                key: '',
                value: '',
            });
        },
        deleteParameter(setting){
            let indexOfSetting = this.form.indexOf(setting);
            this.form.splice(indexOfSetting, 1);
            this.settingsDeleted = true;
        },
        saveParameters(){
            if(this.$refs.formExtraSettings.validate()){
                let settingsToSend = {};
                this.form.map(setting =>{
                    settingsToSend[setting.key] = setting.value
                });

                this.$store.dispatch('patchItem', {
                    item:{
                        url: this.instance.url,
                        extra_settings: settingsToSend,
                    },
                    url: this.$store.state.api.meta.listModels.instances.url,
                    model: 'instances',
                }).then(() => {
                    this.$notify.success({
                        message: this.$t('instance.instance_details.instance_advanced_settings.create_settings_success')
                    });
                    this.$eventBus.$emit('close-instance-details');
                }).catch((error) => {
                    console.error(error);
                    this.$notify.error({
                        message: this.$t('instance.instance_details.instance_advanced_settings.create_settings_error')
                    });
                });
            } else {
                this.$notify.error({
                    message: this.$t('instance.instance_details.instance_advanced_settings.create_settings_error_validation')
                });
            }
        },
    }
};
</script>

<style lang="css" scoped>
.add-new-param{
    cursor: pointer;
}
.delete-params-section{
    cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/page/Instance/InstanceDetails/advanced-settings.vue